import { computed } from 'vue';
import { useRoute } from 'vue-router';

const TENANT_REGEX = /^[A-Fa-f0-9]{6}$/;

export function useUrlSegments() {
  const route = useRoute();

  const segments = computed(() => {
    return route.path.split('/').filter(Boolean); // removes empty segments caused by leading '/'
  });

  // Tenant segment: /([a-f0-9]{6})/
  const tenantId = computed(() => {
    const first = segments.value[0];
    return TENANT_REGEX.test(first ?? '') ? first : null;
  });

  // ignore tenantId if set
  const firstSegment = computed(() => {
    const segs = segments.value;
    if (segs.length === 0) return null;

    if (tenantId.value) {
      return segs[1] ?? null;
    }

    return segs[0];
  });

  const lastSegment = computed(() => {
    const segs = segments.value;
    return segs.length ? segs[segs.length - 1] : null;
  });

  // Get a specific segment by index
  const segment = (index: number): string | null => {
    return segments.value[index] ?? null;
  };

  return {
    segments,
    firstSegment,
    lastSegment,
    segment,
  };
}
